import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import ViewListIcon from "@mui/icons-material/ViewList";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useDispatch } from "react-redux";
import { requestAdhesion } from "../../../actions/art";
import { StyledTransferList } from "../../styled/list";
import ModalTransferList from "../simpleModal/modalTransferList";
import Snackbar from "../snack/snack";
import { customListLeft, customListRight } from "./customList";

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

export default function TransferList({
  artsNotAdhered,
  artsAdhered,
  userName,
}) {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [checked, setChecked] = React.useState([]);
  const [open, setOpen] = React.useState({ open: false, art: [] });
  const [openSnack, setOpenSnack] = React.useState(false);
  const [snackInfo, setSnackInfo] = React.useState({
    variant: "error",
    message: "",
  });

  const leftChecked = intersection(checked, artsNotAdhered);

  const handleOpen = (art) => {
    setOpen({ open: true, art });
  };

  const handleClose = () => {
    setOpen({ open: false, art: [] });
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleCheckedRight = () => {
    handleOpen(checked[0].Name);
  };

  const handleConfirmed = () => {
    dispatch(requestAdhesion(leftChecked[0]))
      .then(() => {
        setChecked(not(checked, leftChecked));
        setOpen({ open: false, art: [] });
        setSnackInfo({
          variant: "success",
          message:
            "Proceso de adhesión iniciado correctamente. Nos esteremos contactando con usted a la brevedad.",
        });
        setOpenSnack(true);
      })
      .catch(() => {
        handleClose();
        setSnackInfo({
          variant: "error",
          message: "El proceso de adhesión no se inició correctamente.",
        });
        setOpenSnack(true);
      });
  };

  return (
    <div>
      <StyledTransferList.Title>Mis ARTs</StyledTransferList.Title>
      <Grid
        container
        spacing={2}
        alignItems="center"
        component={StyledTransferList.Root}>
        <Grid item>
          <StyledTransferList.Text
            sx={{
              color: "#ffffff",
              backgroundColor: theme.palette.primary.main,
            }}>
            <StyledTransferList.StyledIcon>
              <ViewListIcon />
            </StyledTransferList.StyledIcon>
            <p>DISPONIBLES</p>
          </StyledTransferList.Text>
          {customListLeft(artsNotAdhered, checked, leftChecked, handleToggle)}
        </Grid>

        <Grid item>
          <Grid container direction="column" alignItems="center">
            <StyledTransferList.StyledButton
              variant="contained"
              color="primary"
              size="medium"
              onClick={handleCheckedRight}
              disabled={leftChecked.length !== 1}
              aria-label="move selected right">
              &gt;
            </StyledTransferList.StyledButton>
            {leftChecked.length > 1 && (
              <StyledTransferList.Alert>
                No se permite seleccionar más de una ART.
              </StyledTransferList.Alert>
            )}
          </Grid>
        </Grid>

        <Grid item>
          <StyledTransferList.Text
            sx={{
              color: "#ffffff",
              backgroundColor: theme.palette.primary.main,
            }}>
            <StyledTransferList.StyledIcon>
              <PlaylistAddCheckIcon />
            </StyledTransferList.StyledIcon>
            <p>ASIGNADAS</p>
          </StyledTransferList.Text>
          {customListRight(artsAdhered)}
        </Grid>
      </Grid>
      <Snackbar
        open={openSnack}
        handleClose={() => setOpenSnack(false)}
        variant={snackInfo.variant}
        message={snackInfo.message}
      />
      <div>
        {open.open && (
          <ModalTransferList
            open={open.open}
            art={open.art}
            handleClose={handleClose}
            handleConfirmed={handleConfirmed}
          />
        )}
      </div>
    </div>
  );
}
